
<div class="mt-2">
      <div *ngFor="let action of actions" class="subsection mt-2">
        <div class="d-flex justify-content-between align-items-center mb-2 subheader">
          <h4 class="m-0 subsection-title">{{ action.title }}</h4>
          <button class="btn btn-primary btn-sm" (click)="action.method()">{{ action.label }}</button>
        </div>
        <div>
          <p class="mb-2">{{ action.description }}</p>
          <div class="api-response">
            <div [innerHtml]="action.response || 'Waiting for response...'"></div>
          </div>
        </div>
      </div>
</div>

